<template>
    <div class="edit-skills-group-modal">
        <b-modal title="Edit Group" ref="modal" @ok="save" ok-title="Save Changes" header-bg-variant="primary" header-text-variant="light"
                 ok-variant="primary" cancel-title="Cancel" :ok-disabled="loading" :cancel-disabled="loading">
            <b-overlay :show="loading">
                <ClinicalSkillsGroupInformation :group="group" v-if="group"/>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
    import ClinicalSkillsGroupInformation from "../partials/ClinicalSkillsGroupInformation";
    import Providers from '../../../../providers/index';

    export default {
        name: "EditClinicalSkillsGroupModal",
        components: {ClinicalSkillsGroupInformation},
        data() {
            return {
                loading: false,
                groupId: null,
                group: null
            }
        },
        methods: {
            show(groupId) {
                this.group = null;
                this.groupId = groupId;
                this.$refs.modal.show();
                this.loading = true;
                Providers.admin.configuration.clinicalSkillsGroup(groupId).then((resp) => {
                    this.group = resp.body;
                }).catch((resp) => {
                    this.$httpError('Failed to load group', resp);
                }).finally(() => {
                    this.loading = false;
                })
            },
            close() {
                this.$refs.modal.hide();
            },
            save($e) {
                $e.preventDefault();
                this.loading = true;
                Providers.admin.configuration.updateClinicalSkillsGroup(this.groupId, this.group).then(() => {
                    this.$success('Updated Clinical Skills Group', 'The group has been updated successfully');
                    this.$emit('group-updated');
                    this.close();
                }).catch((resp) => {
                    this.$httpError('Failed to update group', resp);
                }).finally(() => {
                    this.loading = false;
                })
            },

        }
    }
</script>

<style scoped>

</style>